import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft, Home } from "lucide-react";

const MerchantPaymentCancel = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl border border-slate-800 p-8 text-center shadow-lg">
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-10 w-10 text-red-500" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-white mb-2" data-testid="merchant-payment-cancelled">
            Payment Cancelled
          </h1>
          <p className="text-gray-500 mb-8">
            Your subscription payment was cancelled. No charges have been made to your account.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/pricing">
              <Button className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 rounded-full" data-testid="back-to-pricing-btn">
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back to Pricing
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full h-12 border-slate-700 text-white hover:bg-gray-100 rounded-full">
                <Home className="h-5 w-5 mr-2" />
                Return Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantPaymentCancel;
